import { MARKET_MOCK_HANDLERS } from '@arya/market/mock';
import { MARKET_PROJECT_MOCK_HANDLERS } from '@arya/market/project/mock';

import type { RequestHandler } from 'msw';

import { DEV_SCENARIO_ENTRIES, LAST_DEV_SCENARIO_ENTRIES } from './dev-scenario-entries';

export const DEV_SCENARIO_HANDLERS: readonly RequestHandler[] = [
  ...MARKET_MOCK_HANDLERS,
  ...MARKET_PROJECT_MOCK_HANDLERS,
  ...DEV_SCENARIO_ENTRIES.map(({ handler }) => handler),
  ...LAST_DEV_SCENARIO_ENTRIES.map(({ handler }) => handler),
];
